// import { getTime } from 'date-fns'
const INFO_TYPE = 0
const ATENTION_TYPE = 1
const CAUTION_TYPE = 2
const CRITICAL_TYPE = 3

export const state = {
  statInfo: null,
  logSize: null,
  sysHealth: null,
  p11Info: null
}

export const getters = {
  getWarnings: state => {
    const statInfo = state.statInfo
    const logSize = state.logSize
    const sysHealth = state.sysHealth
    let isPocket
    if (state.p11Info) isPocket = state.p11Info.model === 'DMP'
    const warnings = []

    if (statInfo) {
      // UPPACK
      if (statInfo.pending_upack) {
        warnings.push({ title: 'pending_upack', type: INFO_TYPE, message: statInfo.pending_upack })
      }
      // BACKUP
      if (statInfo.pending_backup) {
        warnings.push({ title: 'pending_backup', type: INFO_TYPE })
      }
      // DATE TIME
      if (statInfo.current_dt_info) {
        const hsmDate = new Date(statInfo.current_dt_info * 1000)
        const realDate = new Date()
        const diff = Math.abs(hsmDate.getTime() - realDate.getTime())
        const hourDiff = diff / (1000 * 3600)
        if (hourDiff >= 1) {
          warnings.push({ title: 'current_dt_info', type: CAUTION_TYPE })
        }
      }

      // BASE
      let MAX_BASE_SIZE
      if (isPocket) MAX_BASE_SIZE = 200
      else MAX_BASE_SIZE = 2 ** 20
      if (statInfo.obj_count) {
        const usedPercent = Math.floor(
          (statInfo.obj_count / MAX_BASE_SIZE) * 100
        )
        if (usedPercent > 85) {
          let type
          if (usedPercent <= 95) type = ATENTION_TYPE
          else if (usedPercent < 100) type = CAUTION_TYPE
          else if (usedPercent === 100) type = CRITICAL_TYPE
          warnings.push({
            title: 'sl_be_len',
            type,
            titleArgs: { usedPercent }
          })
        }
      }

      // STORAGE
      if (statInfo.total_blocks && statInfo.free_blocks) {
        const usedPercent = Math.floor(
          (1 - statInfo.free_blocks / statInfo.total_blocks) * 100
        )
        if (usedPercent > 85) {
          let type
          if (usedPercent <= 95) type = ATENTION_TYPE
          else if (usedPercent < 100) type = CAUTION_TYPE
          else if (usedPercent === 100) type = CRITICAL_TYPE
          warnings.push({
            title: 'storage_size',
            type,
            titleArgs: { usedPercent }
          })
        }
      }
    }

    // LOG SIZE
    if (logSize) {
      const MAX_LOG_LINE = 1024
      let MAX_LOG_SIZE
      if (isPocket) MAX_LOG_SIZE = 0x7fffffff - 2 * MAX_LOG_LINE
      else MAX_LOG_SIZE = 0xffffffff - 2 * MAX_LOG_LINE
      const USED_LOG = Math.round((logSize / MAX_LOG_SIZE) * 1000) / 10

      if (USED_LOG >= 85) {
        let type
        if (USED_LOG <= 95) type = ATENTION_TYPE
        else if (USED_LOG < 100) type = CAUTION_TYPE
        else if (USED_LOG >= 100) type = CRITICAL_TYPE
        warnings.push({
          title: 'log_size',
          type,
          titleArgs: USED_LOG
        })
      }
    }
    // BATERY
    if (!isPocket && sysHealth && sysHealth.battery_ok) {
      if (sysHealth.battery_ok !== 1) {
        warnings.push({
          title: 'battery_ok',
          type: CRITICAL_TYPE
        })
      }
    }
    // ORDENAR por tipo
    return warnings
  }
}

export const mutations = {
  SET_STAT_INFO (state, payload = null) {
    state.statInfo = payload
  },
  SET_LOG_SIZE (state, payload = null) {
    state.logSize = payload
  },
  SET_SYS_HEALTH (state, payload = null) {
    state.sysHealth = payload
  },
  SET_P11_INFO (state, payload = null) {
    state.p11Info = payload
  }
}

export const actions = {
  async load ({ rootState, commit, dispatch }) {
    const hsm = rootState.hsm.instance

    try {
      const res = await Promise.all([
        hsm.getStatInfo({ body: { info: 9 } }),
        hsm.getLogSize({ body: {} }),
        hsm.getSysHealth({ body: {} }),
        hsm.getP11Info({ body: {} })
      ])

      commit('SET_STAT_INFO', res[0])
      commit('SET_LOG_SIZE', res[1])
      commit('SET_SYS_HEALTH', res[2])
      commit('SET_P11_INFO', res[3])
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  }
}
